import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)

export class MailApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.accessToken = container.get('services.oauth') ? container.get('services.oauth').getToken() : null
	}

	list (params) {
		return Vue.http.post(this.url + '/mail-list', params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}

	confirm (token, params) {
		return Vue.http.post(this.url + '/newsletter/confirm/' + token, params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}

	subscribe (params) {
		return Vue.http.post(this.url + '/newsletter/subscribe', params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}
}
